import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { useDispatch } from 'react-redux' 
import { updateEmployer, updateAvailableEmployers } from '../store/user';
import logo from '../svg/logo.svg';
import { useAuth } from './auth/Auth';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
}), {});
const personal = { org_id: 0, org_name: 'Personal' };
function Aside({ user }) {
  const { employer } = useAuth();
  const [employerOptions, setEmployerOptions] = useState([]);
  const [activeEmployer, setActiveEmployer] = useState({});
  const [isPersonal, setIsPersonal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if(user.employers && user.employers.length){
      
      const options = [personal, ...user.employers]
        .map(e => ({ 
          value: e.org_id, 
          label: e.org_name, 
          logo: e.org_logo }));
      setEmployerOptions(options);
      if(employer && options.find(e => e.value === employer.value)){
        setIsPersonal(false);
        setActiveEmployer(options.find(e => e.value === employer.value));
      } else {
        setIsPersonal(true);
        setActiveEmployer(options[0]);
      }
    } else {
      setActiveEmployer(personal);
      setIsPersonal(true);
    }
  }, [user])

  useEffect(() => {
    dispatch(updateEmployer(activeEmployer));
    if(activeEmployer.value === 0)
      setIsPersonal(true);
    else
      setIsPersonal(false);
  }, [activeEmployer])


  return (
    <aside
      id="default-sidebar"
      className="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0 bg-gray-800"
      aria-label="Sidebar"
    >
      <div className="h-full px-3 py-4 overflow-y-auto bg-gray-800 border-b-gray-200">
        <a
          href="https://productions.com/"
          className="flex items-center pl-2.5 mb-5"
        >
          <img src={logo} alt="Productions" />
        </a>
        <ul className="space-y-2">
          { employerOptions.length ? <li>
            <form>
              <label
                htmlFor="active-employers"
                className="block mb-2 text-lg font-medium text-gray-900 text-white">Select Employer</label>
              <Select
                id="active-employers"
                name="active-employers"
                value={activeEmployer}
                onChange={setActiveEmployer}
                options={employerOptions}>
              </Select>
              
            </form>
          </li> : <></>
        }
          <li>
            <a
              href="/admin/dashboard"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
                <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
              </svg>
              <span className="ml-3">Dashboard</span>
            </a>
          </li>
          { !isPersonal && <li>
            <a
              href="/admin/jobs"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
              <span className="ml-3">Jobs</span>
            </a>
          </li>
        }
        { !isPersonal && activeEmployer.value === '35d42b9e-e2f5-4070-8827-535eceb8ff12' && <li>
            <a
              href="/admin/users"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
              <span className="ml-3">Users</span>
            </a>
          </li>
        }
        { !isPersonal && <li>
            <a
              href="/admin/projects"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
              <span className="ml-3">Projects</span>
            </a>
          </li>
        }
        { !isPersonal && activeEmployer.value === '35d42b9e-e2f5-4070-8827-535eceb8ff12' && 
          (<><li>
            <a
              href="/admin/employers"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
              <span className="ml-3">Employers</span>
            </a>
          </li>
          <li>
            <a
              href="/admin/companies"
              className="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white hover:bg-gray-700"
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-400 transition duration-75 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
              <span className="ml-3">Companies</span>
            </a>
          </li></>)
        }
        </ul>
      </div>
    </aside>
  );
}

export default connector(Aside);